(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerIsStickyOnScrollUp = this.getAttribute('data-sticky-type') === 'on-scroll-up';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.revealOffset = 10;
      this.preventReveal = false;
      this.hideAnimationFrame = null;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const headerHeight = this.offsetHeight || this.querySelector('.header')?.offsetHeight || this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.cancelAnimationFrame(this.hideAnimationFrame);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isPastRevealOffset = scrollTop > this.revealOffset;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && isPastRevealOffset) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && isPastRevealOffset) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventReveal) {
          this.preventReveal = false;
          requestAnimationFrame(this.hide.bind(this));
        } else {
          requestAnimationFrame(this.reveal.bind(this));
        }
      } else if (scrollTop <= this.revealOffset) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      const wasSticky = this.header.classList.contains('shopify-section-header-sticky');
      this.header.classList.add('shopify-section-header-sticky', 'animate');

      if (this.header.classList.contains('shopify-section-header-hidden')) {
        this.closeMenuDisclosure();
        this.closeSearchModal();
        return;
      }

      window.cancelAnimationFrame(this.hideAnimationFrame);
      if (wasSticky) {
        this.header.classList.add('shopify-section-header-hidden');
      } else {
        this.hideAnimationFrame = window.requestAnimationFrame(() => {
          this.hideAnimationFrame = null;
          this.header.classList.add('shopify-section-header-hidden');
        });
      }

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      window.cancelAnimationFrame(this.hideAnimationFrame);
      this.hideAnimationFrame = null;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      window.cancelAnimationFrame(this.hideAnimationFrame);
      this.hideAnimationFrame = null;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
